<template>
    <div class="trz_leave_settings">
        
        <template>
            <!--<div class="row mt-4">-->
            <div class="clearfix row py-2 mb-2 mt-5 no-margin border-bottom">       
                <div class=" col-sm-12 text-right pr-0">
                    <b-button id="show-btn" class="" v-if="ce" @click="addNew()"><b-icon icon="plus" ></b-icon> Add Leave</b-button>
                </div>
            </div>
        
            <div class="row justify-content-center no-margin">
            <div class="col-sm-12  px-0">            
                <b-overlay :show="showoverlay_list" rounded="sm">

                 <table class="table dataTable"> 
                        <thead class="" style="">
                            <tr class="table-head">
                                <td class="" v-for="column in columns" :key="column.name" @click="sortBy(column.name)":class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"style="cursor:pointer;" v-if="column.name!='employee_name'"><span >{{column.label}}</span></td>
                                <td class="text-right" v-if="ce">Action</td>
                            </tr>
                        </thead>
                        <tbody> 
                            <tr class="table-row hover-bg" v-for="(leave , n) in paginatedData" :key="n">
                               
                                <td class="">
                                    {{leave.leave_type}}
                                </td>
                                <td class="">
                                    {{leave.from}}
                                </td>
                                <td class="">                                    
                                    {{ leave.to }}
                                </td>
                                <td class="">
                                    {{leave.number_of_days}}
                                    <span v-if="leave.number_of_days > 1">days</span>
                                    <span v-else>day</span> 
                                </td>
                                <td class="">
                                    {{leave.reason}}
                                </td>
                                
                                <td class="">
                                    <span class="leave-status" v-if="leave.status == 'Approved'"><i class="far fa-dot-circle mr-1 text-success"></i>{{leave.status}}</span>
                                    <span class="leave-status" v-if="leave.status == 'Applied'"><i class="far fa-dot-circle mr-1 text-primary"></i>Pending</span>
                                    <span class="leave-status" v-if="leave.status == 'Declined'"><i class="far fa-dot-circle mr-1 text-danger"></i>{{leave.status}}</span>
                                </td>
                                                                    
                                <td class="position-relative text-right" v-if="ce">                        
                                    <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                    <div class="dropdown-menu action-dropdown-menu w-200" aria-labelledby="actionDropdown">
                                        <b-button-group class="mr-0"><!--@click="editLeave(leave.employee_id,leave.leave_type_id,leave.flg_status,leave.from,leave.to)"-->
                                            <b-button class="mr-3 rounded edit-btn" title="Edit Work Location" @click="updateLeave(leave.id)" >
                                                <b-icon icon="pencil" class="mr-2" aria-hidden="true" ></b-icon>Edit
                                            </b-button>
                                            <b-button class="rounded delete-btn" title="Delete Work Location" @click="deleteLeave(leave.employee_id,leave.leave_type_id,leave.flg_status,leave.from,leave.to)">
                                                <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Delete
                                            </b-button>                                                
                                        </b-button-group>
                                    </div>
                                    
                                </td>
                            </tr>
                        </tbody>
                    </table>
                   <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                    <div v-else class=""><b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ><template #prev-text><span>Previous</span></template><template #next-text><span>Next</span></template></b-pagination-nav></div>
                   </b-overlay>
               </div>
            </div>
            <b-modal id="bv-modal-edit-leave" size="xl" scrollable  hide-footer title="Leave Details">            
            <!-- leave_type_id , flg_status , from , to -->
            
                <employee-leave-details v-if="this.employee_id >= 0" :editflg="1" :leave_type_id="this.tmp_leave_type_id" :flg_status="this.tmp_flg_status" :from="this.tmp_from" :to="this.tmp_to" v-on:childToParent="getLeaves"></employee-leave-details>
            </b-modal>

             <b-modal id="bv-modal-leave"  hide-footer v-bind:title="leave_details.leave_date" v-if="ce">
                    <b-form @submit.stop.prevent="onSubmitLeaveUpdate">
                        <input type="hidden" v-model="leave_details.id" name="id">
                        
                        <b-form-group id="status-group" label="Status" label-for="status">
                            <b-form-select id="status" name="status" v-model="leave_details.flg_status" v-validate="{ required: true }" :options="leavestatus"></b-form-select>
                            
                        </b-form-group>

                        <b-button type="submit" variant="success">Submit</b-button> 

                    </b-form>
                </b-modal>

            <b-modal id="bv-modal-at-add-leave" size="xl" scrollable  hide-footer title="Leave Details">            
                <div class="col-sm-12" v-if="ce">
                    <div class="card ">
                        <div class="card-header">
                            Apply for Leave 
                        </div>
                        <div class="card-body">
                            <div>Select Day / Range</div>
                            <div class="row">                            
                                <div class="col-sm-6">From<b-form-datepicker id="day_one" @context="updateToDate()"   v-model="day_one" :date-disabled-fn="dateDisabled" :start-weekday="fetchStartWeekday"></b-form-datepicker></div>
                                <div class="col-sm-6">To <b-form-datepicker id="day_two" :min="min"  v-model="day_two" :date-disabled-fn="dateDisabled" :start-weekday="fetchStartWeekday"></b-form-datepicker></div>
                                
                            </div>
                            <div class='mt-2'>                             
                                <div class="row">                            
                                    <div class="col-sm-6">
                                        
                                        <b-form-group id="leave_type_id-group" label="Leave Type" class="required-field" label-for="leave_type_id">
                                                                                        
                                            <b-form-select id="leave_type_id" name="leave_type_id" v-model="fdata.leave_type_id" v-validate="{ required: true  }"  :state="validateState('leave_type_id')" aria-describedby="leave_type_id-feedback" data-vv-as="Leave Type">
                                                
                                                <b-form-select-option v-for="leave_type in leavetypes" :key="leave_type.leave_type_id" :value="leave_type.leave_type_id">{{leave_type.leave_type_title}}</b-form-select-option>

                                            </b-form-select>                                            
                                            
                                            
                                            <b-form-invalid-feedback id="leave_type-feedback">{{ veeErrors.first('leave_type_id') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </div>
                                    <div class="col-sm-6">
                                        <b-form-group id="comment-group" label="Reason/Comment" label-for="comment">
                                            <b-form-textarea id="comment" name="comment" rows="3" max-rows="6" no-resize v-model="fdata.comment"  v-validate="{required: true, min: 3 }" :state="validateState('comment')" aria-describedby="comment-feedback" data-vv-as="Reason/Comment"></b-form-textarea>
                                            <b-form-invalid-feedback id="comment-feedback">{{ veeErrors.first('comment') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </div>
                                    
                                </div>
                                
                                <div class="clearfix">
                                    <div class="float-left"><b-button :disabled="disable_flg" variant="success" @click="saveLeave()">Save</b-button></div>   
                                    <div class="float-right font-italic" :class="my_class">Day(s) : {{dateDiff}}</div>   
                                </div>
                            </div>

                             <!--<div class="row mt-4">

                               <div class="col-sm-12">
                                    
                                    Allowed Leaves:
                                    <div v-for="leave_type in leave_available">
                                        {{leave_type.leave_title}} : Allowed {{leave_type.leave_days}} days with {{leave_type.remaining_days}} days remaining.
                                    </div>

                                </div>
                                
                            </div>-->
                            
                            

                            
                        </div> 
                    </div>
                </div>
                <div class="col-sm-8" v-else>
                    Can not apply leave for an ex employee.
                </div>
            </b-modal>

                

        </template>
    </div>
</template>
<script>    
    
    import moment from 'moment'

    export default{
        
        mounted() {
            
        }, 
        components: {
            
        },     
        data(){
            
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            // 15th two months prior
            const minDate = new Date(today)
            minDate.setMonth(minDate.getMonth())
            minDate.setDate(minDate.getDate() + 1)
            /*const maxDate = new Date(today)
            maxDate.setMonth(maxDate.getMonth() + 2)
            maxDate.setDate(15)*/
            const startdate = minDate

            /** Aboni Code Starts Here */
            
            let sortOrders = {};
            let columns = [
                            {label: 'Employee', name: 'employee_name' },
                            {label: 'Leave Type', name: 'leave_type'},
                            {label: 'From', name: 'from'},
                            {label: 'To', name: 'to'},
                            {label: 'No of Days', name: 'number_of_days'},
                            {label: 'Reason', name: 'reason'},
                            {label: 'Status', name: 'status'},
                        ];
            columns.forEach((column) => {sortOrders[column.name] = -1;});
            
            /** Aboni Code Ends Here */

            return {

                /** Aboni Code Starts Here */
                columns: columns,
                sortKey: 'employee_name',
                sortOrders: sortOrders, 

                length: 20,
                pagination: {currentPage: 1, pages:1}, 

                tmp_leave_type_id : 0,
                tmp_flg_status : 0,
                tmp_from : '',
                tmp_to : '',               
                /** Aboni Code Ends Here */

                min: minDate,
                //max: maxDate,
                day_one:startdate , day_two:startdate,
                fdata : {day_one:startdate , day_two:startdate, days:null , leave_type_id:null , comment:null},
                leave_details : {},
                company_id : 0 ,

                ce : true,

                my_class : '',
                
                blankmsg : 'Fetching data..',

                holidays : [],
                leaves : [],
                holidays_date_arr : [],
                leave_limit : [],
                leave_available : [],
                disable_flg : false,
                
                week_holidays : [6],
                all_week_holidays : [6],
                week_start_day : 7,
                count_options: [
                            { value: 1, text: '1' },
                            { value: 2, text: '2' },
                            { value: 3, text: '3' },
                            { value: 4, text: '4' },
                            { value: 5, text: '5' },
                            { value: 6, text: '6' },
                            { value: 7, text: '7' },
                            { value: 8, text: '8' },
                            { value: 9, text: '9' },
                        ],

                
                options: [
                    { text: 'Friday', value: '5' },
                    { text: 'Saturday', value: '6' },
                    { text: 'Sunday', value: '0' },
                    { text: 'Monday', value: '1' },
                    { text: 'Tuesday', value: '2' },
                    { text: 'Wednesday', value: '3' },
                    { text: 'Thursday', value: '4' }
                ],
                //1 for casual leave, 2 for sick leave, 3 for annual leave, 4 for unpaid leave, 5 for compaensatory leave 
                leavetypes: [],
                
                leavestatus: [
                    { text: 'Applied', value: '0' },
                    { text: 'Approved', value: '1' },
                    { text: 'Refused', value: '2' },
                ],       
                
            }
        },
        methods:{

            canEdit: function()
            {                
                axios.get(this.$api_url+'/canedit' , {
                    params: {
                        
                    }
                }).then(function(response){
                    this.ce = response.data;         
                }.bind(this));
            },
            dateDisabled(ymd, date) {
                const x = moment(String(date)).format('YYYY-MM-DD');
                const weekday = date.getDay();
                const day = date.getDate();                
                return this.all_week_holidays.includes(weekday) || this.holidays_date_arr.includes(x);
            },
            updateToDate:function()
            {
                this.day_two = this.day_one;
                this.min = this.day_one;
            },            
            formatdate:function(x) 
            {
                return moment(x).format('Do MMMM YYYY');
            },
            checkGaterDate(x)
            {
                return moment(x).isAfter(moment(new Date()).format('YYYY-MM-DD'));
            },
            getEmployeeLeaveSettings:function() 
            {   
                
                axios.get(this.$api_url+'/employee/leave/settings' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){
                    
                    if(response.data.length != 0)
                    {
                        console.log( response.data);
                        this.company_id =  response.data.company_id;
                        this.all_week_holidays = response.data.week_holidays;
                        this.week_holidays = response.data.week_holidays.split(',');
                        this.week_start_day =  response.data.week_start_day;

                        
                    }       
                    
                }.bind(this));

            },
            getLeaveTypeByLeavePolicy: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                axios.get(this.$api_url+'/leave/type/by/leave/policy' , {
                    params: {
                        
                    }
                }).then(function(response){
                    
                    this.leavetypes = response.data;
                    
                }.bind(this));
            }, 
            updateLeave : function(x)
            {
                //leave_details
                axios.get(this.$api_url+'/employee/leave/details?id='+x , {
                    params: {
                        //id: x
                    }
                }).then(function(response){

                    //console.log(response.data);
                    
                    this.leave_details = response.data;    
                    
                }.bind(this));
                this.$bvModal.show('bv-modal-leave');
            }, 
            onSubmitLeaveUpdate : function()
            {
                let currentObj = this;
                let formData = new FormData();
                for (let [key, value] of Object.entries(this.leave_details)) 
                {                    
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);                    
                    
                } 
                axios.post(this.$api_url+'/employee/leave/details', formData,)
                            .then(function (response) 
                            {                             
                                this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });  

                                this.getLeaves(); 
                                this.$bvModal.hide('bv-modal-leave');
                                this.$emit('childToParent');        
                                
                            }.bind(this))
                            .catch(function (error) 
                            {                                    
                                currentObj.serverError(error);
                            });
            },        
            getHoliDays:function() 
            {   
                axios.get(this.$api_url+'/company/holidays' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){
                    
                    if(response.data.length != 0)
                    {
                        //console.log( response.data);                        
                        this.holidays = response.data.holidays;
                        this.holidays_date_arr = response.data.holidays_date_arr.split(',').map(function(item){ return item;});
                    }       
                    
                }.bind(this));

            },
            getLeaves: function()
            {
                if(!this.checkNet()) return false;
                this.employee_id = 0;
                this.$bvModal.hide('bv-modal-leave-details');
                let currentObj = this;
                axios.get(this.$api_url+'/employees/leaves/fiscalyear' , {
                    params: {
                        employee_flag: 1
                    }
                }).then(function(response){
                    this.leaves = response.data;

                    this.$bvModal.hide('bv-modal-edit-leave');
                    this.$bvModal.hide('bv-modal-add-leave');
                    //console.log(this.leaves);

                    
                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },
             
          



            saveLeave:function()
            {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    let currentObj = this;
                    let formData = new FormData();
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);                    
                        //console.log(`${key}: ${value}`);
                    } 

                    
                    axios.post(this.$api_url+'/employee/leaves', formData,)
                                .then(function (response) 
                                {                             
                                    if(response.data.status)
                                    {
                                        
                                        //this.leaves = response.data.leave_data;
                                        //this.leave_limit = response.data.limit;
                                        this.getLeaves();


                                        this.$bvToast.toast('Saved!', {
                                                title: `Success`,
                                                variant: 'success',
                                                solid: true
                                            }); 
                                    }
                                    else
                                    {
                                        this.$bvToast.toast(response.data.message, {
                                                title: `Warning`,
                                                variant: 'warning',
                                                solid: true
                                            }); 
                                    }
                                    
                                    
                                }.bind(this))
                                .catch(function (error) 
                                {                                    
                                    currentObj.serverError(error);
                                });
            
                });
            }, 


            editLeave: function(employee_id , leave_type_id , flg_status , from , to)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;

                this.employee_id = 0;
                let formData = new FormData();
                formData.append('employee_id' , employee_id);
                axios.post(this.$api_url+'/employee/setemployee', formData)
                    .then(function (response) 
                    {    
                        this.employee_id = employee_id;

                        this.tmp_leave_type_id = leave_type_id;
                        this.tmp_flg_status = flg_status;
                        this.tmp_from = from;
                        this.tmp_to = to;

                        this.$bvModal.show('bv-modal-edit-leave');
                        
                    }.bind(this))
                    .catch(function (error) 
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });

                
            },
            deleteLeave: function(employee_id , leave_type_id , flg_status , from , to)
            {

            },
            addNew()
            {
               // this.employee_id = 0;
                this.$bvModal.show('bv-modal-at-add-leave');
            },

            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            fetchDateDisabled()
            {                
                return this.week_holidays;
            }
        },
        created: function(){
            this.canEdit();
            this.getEmployeeLeaveSettings();
            this.getLeaveTypeByLeavePolicy();
            this.getHoliDays();
            this.getLeaves();
        },
        computed: 
        {
            dateDiff()
            {
                //fdata : {day_one:null , day_two:null, days:null , details:null},
                this.disable_flg = false;
                
                var day_one = moment(this.day_one);
                var day_two = moment(this.day_two);  

                let days = 0;

                this.fdata.day_one = moment(String(this.day_one)).format('YYYY-MM-DD');
                this.fdata.day_two = moment(String(this.day_two)).format('YYYY-MM-DD');

                if(this.day_one === this.day_two)
                {
                    this.fdata.days = 1;
                    //return 1;
                    days = 1;
                }
                else
                {
                    days = day_two.diff(day_one, 'days') // 1

                    ++days;
                }
                

                
                if(days > 0)
                {
                    
                    this.fdata.days = days;

                    if(days > this.leave_limit[this.fdata.leave_type_id])
                    {
                        this.disable_flg = true;

                        this.my_class = 'danger';

                        return 'Limit Exceed!';
                    }
                    else
                    {
                        this.disable_flg = false;
                        this.my_class = '';
                        return days;
                    }
                    
                }                   
                else if(days < 0)
                {
                    this.fdata.days = 0;
                    this.disable_flg = true;
                    return 'Invalid Date Range';
                }                
                    
            },
            fetchStartWeekday()
            {
                return this.week_start_day;
            },

            /*Aboni code*/
            filteredData() 
            {
                let filtered_list = this.leaves;
                if (this.search) 
                {
                  
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
                
                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";                
                }

                let sortKey = this.sortKey;
                let order = this.sortOrders[sortKey] || 1;
                if (sortKey) 
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();
                            if (this.columns[index].type && this.columns[index].type === 'date') 
                            {
                                return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            } 
                            else if (this.columns[index].type && this.columns[index].type === 'number') 
                            {
                                return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                            } 
                            else 
                            {
                                return (a === b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }
                
                return filtered_list;
            },
            paginatedData() 
            {     
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
            
        }
    }
</script>
<style >
    .trz_leave_settings .custom-select{width: auto !important;}
    .trz_list li{margin-top:5px;}
    .danger{color:red;}
</style>